import { AccentPaletteColor } from "~/lib/accentPalette";

interface ColorSwatchGridProps {
  colors: AccentPaletteColor[];
  color: string;
  onChange: (color: string) => void;
}

// Accent color swatch picker shared by the agent / dataset / project appearance dialogs.
export const ColorSwatchGrid = ({ colors, color, onChange }: ColorSwatchGridProps) => (
  <div className="flex flex-wrap gap-2.5">
    {colors.map((swatch) => {
      const ringColor = swatch.fg ?? swatch.accent;
      return (
        <button
          key={swatch.accent}
          type="button"
          aria-label={`Use color ${swatch.name}`}
          aria-pressed={color === swatch.accent}
          onClick={() => onChange(swatch.accent)}
          className="size-7 cursor-pointer rounded-full border-2"
          style={{
            backgroundColor: swatch.bg,
            borderColor: ringColor,
            boxShadow:
              color === swatch.accent
                ? `0 0 0 2px var(--background), 0 0 0 4px ${ringColor}`
                : undefined,
          }}
        />
      );
    })}
  </div>
);
